module.exports = __webpack_public_path__ + "img/learner-quiz-Competitor-Shadow.e4a8346a.png";